import { $ } from '@zimpa/dom';

const STICK_CLASS = 'h-stick';

export function stick(): void {
    const probe = $('.js-stick-probe');
    const observer = new IntersectionObserver(
        (entries: IntersectionObserverEntry[]): void => {
            entries.forEach((entry: IntersectionObserverEntry): void => {
                if (entry.isIntersecting) {
                    window.document.body.classList.remove(STICK_CLASS);
                } else {
                    window.document.body.classList.add(STICK_CLASS);
                }
            },{threshold: 0.01});
        },
    );

    if (probe !== undefined) {
        observer.observe(probe);
    }
}
